import { render, staticRenderFns } from "./myFeesPage.vue?vue&type=template&id=4db9403b&scoped=true"
import script from "./myFeesPage.vue?vue&type=script&lang=ts"
export * from "./myFeesPage.vue?vue&type=script&lang=ts"
import style0 from "./myFeesPage.vue?vue&type=style&index=0&id=4db9403b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9403b",
  null
  
)

export default component.exports